import React from 'react';
import styled from 'styled-components';
import { Heading3, Heading4, P, Margin } from '@ovotech/element-v5';
import { breakpoints } from '@/src/utils/mediaQuery';
import SunSvg from './Sun.svg';
import CarSvg from './Car.svg';
import TicketSvg from './Ticket.svg';
import PresentSvg from './Present.svg';
import useWindowDimensions from '@/src/utils/hooks/useWindowDimensions';
import { RewardsCard } from './RewardsCard';

const Heading = styled(Heading3)`
  color: ${({ theme }) => theme.colors.brand.midnight};
`;

const BenefitItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: ${({ theme }) => theme.space[4]};
  margin-bottom: ${({ theme }) => theme.space[6]};

  @media ${breakpoints.smallDown} {
    flex-direction: column;
    gap: 0;
  }
`;

const BenefitIcon = styled.img`
  width: 80px;
  height: 80px;
  flex-shrink: 0;

  @media ${breakpoints.smallDown} {
    width: 44px;
    height: 44px;
  }
`;

const BenefitTitle = styled(Heading4)`
  color: ${({ theme }) => theme.colors.brand.midnight};
`;

const BenefitContent = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 420px;

  @media ${breakpoints.smallDown} {
    max-width: 300px;
  }
`;

const benefits = [
  {
    icon: PresentSvg,
    alt: 'giveaways',
    title: 'You could win big',
    description:
      'From energy credits to a free TV, we regularly give our customers the chance to get even more. Keep your eyes peeled for our next giveaway.',
  },
  {
    icon: SunSvg,
    alt: 'solar panels',
    title: 'Free solar panels',
    description:
      'Save for a greener home. Earn up to 5 solar panels to help cut your future bills.',
  },
  {
    icon: CarSvg,
    alt: 'electric miles',
    title: 'Free electric miles',
    description: 'Bank up to 2,400 free miles for your future electric car.',
  },
  {
    icon: TicketSvg,
    alt: 'partner perks',
    title: 'Partner perks',
    description: 'Enjoy discounts and treats from brands you love.',
  },
];

export const Rtbs = () => {
  const { isMobile } = useWindowDimensions();

  return (
    <RewardsCard>
      <div>
        <Heading>Benefits you can unlock</Heading>
        <Margin top={isMobile ? 5 : 8}>
          {benefits.map(benefit => (
            <BenefitItem key={benefit.title}>
              <BenefitIcon src={benefit.icon} alt={benefit.alt} />
              <BenefitContent>
                <BenefitTitle>{benefit.title}</BenefitTitle>
                <Margin top={2}>
                  <P>{benefit.description}</P>
                </Margin>
              </BenefitContent>
            </BenefitItem>
          ))}
        </Margin>
      </div>
    </RewardsCard>
  );
};
